/* ===============================
   BASIC HELPERS
================================ */

export const isNonEmptyText = (value: string, minLength = 2): boolean => {
  return value.trim().length >= minLength;
};

export const isMeaningfulText = (value: string): boolean => {
  const text = value.toLowerCase().trim();

  // must contain at least one vowel
  if (!/[aeiou]/.test(text)) return false;

  // block long consonant chains (gfhgh, sdfsdf)
  if (/[bcdfghjklmnpqrstvwxyz]{5,}/i.test(text)) return false;

  // must be at least 4 chars
  if (text.length < 4) return false;

  // block repeated patterns like sdfsdf
  if (/(\w{2,})\1+/.test(text)) return false;

  return true;
};



/* ===============================
   URL & DOMAIN
================================ */

export const normalizeUrl = (url: string): string => {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return `https://${url}`;
  }
  return url;
};

export const isValidUrl = (url: string): boolean => {
  try {
    const parsed = new URL(normalizeUrl(url));
    return ["http:", "https:"].includes(parsed.protocol);
  } catch {
    return false;
  }
};

export const isValidDomain = (url: string): boolean => {
  const domainRegex =
    /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
  return domainRegex.test(url);
};

/* ===============================
   KEYWORDS
================================ */

export const isValidKeywordList = (keywords: string): boolean => {
  const list = keywords
    .split(",")
    .map(k => k.trim())
    .filter(Boolean);

  return list.length > 0 && list.every(k => k.length >= 2);
};

/* ===============================
   AI TEXT INPUT (Rewrite tools)
================================ */

export const isValidRewriteText = (text: string): boolean => {
  if (text.trim().length < 20) return false;
  return isMeaningfulText(text);
};

